import {Injectable} from "@angular/core";

/**
 * Class for locally storing small values that can be easily accessed.
 * These values will also be available on the server when performing Server Side Rendering (SSR).
 */
 @Injectable()
export abstract class StorageLocal {

    public abstract getItem(key: string): string | null;

    public abstract setItem(key: string, value: string): void;

    public abstract removeItem(key: string): void;

    public abstract clear(): void;

}
